<template>
    <svg-icon
        :fill="isFilled"
        :name="name"
        v-on="$listeners"
    />
</template>

<script>
    import SvgIcon from 'vue-svgicon';

    export default {
        name: 'Icon',

        components: {
            SvgIcon,
        },

        props: {
            name: {
                type: String,
                required: true,
            },
        },

        computed: {
            isFilled() {
                return this.name.includes('bold/');
            },
        },
    };
</script>

<style>
    .svg-icon {
        height: 1em;
        width: 1em;
        display: inline-block;
        vertical-align: middle;
        fill: none;
        stroke: currentColor;
    }

    .svg-fill {
        fill: currentColor;
        stroke: none;
    }
</style>
